import { useState } from 'react'
import { Menu, MenuItem } from '@mui/material'
import { withStyles } from '@mui/styles'
import StyledPopup from './StyledPopup'

export const StyledMenu = withStyles({
    paper: {
        minWidth: '30px',
        borderRadius: 4,
        marginTop: 8,
    },
    list: {
        paddingTop: 0,
        paddingBottom: 0
    }
})((props) => (
    <Menu
      getcontentanchorel={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      {...props}
    />
));

export const StyledMenuItem = withStyles(theme => ({
    root: {
        color: '#5A5A5A',
        justifyContent: 'center',
        fontSize: '14px',
        paddingTop: 3,
        paddingBottom: 3,
        minHeight: 0,
        '& + .MuiDivider-root': {
            marginTop: 0,
            marginBottom: 0
        }
    },
    selected: {
      backgroundColor: theme.palette.primary.main + ' !important',
      color: 'white'
    },
}))(MenuItem); 

function StyledSelect(props) {
    const { handleChange, items, value, style, closeOnClick = true} = props;
    const [anchorEl, setAnchorEl] = useState(null);

    function handleItemClick(event){
        if (closeOnClick)
            setAnchorEl(null);
        handleChange(items[event.target.value]);
    };

    return (
    <div style={style}>
        <StyledPopup value={value} open={anchorEl !== null} handleClick={e => setAnchorEl(e.currentTarget)} />
        <StyledMenu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        >
            {items.map((item,index) => (<StyledMenuItem 
            selected={value === item} 
            key={index} 
            tabIndex={index}
            value={index} 
            onClick={(e) => handleItemClick(e)}>{item}</StyledMenuItem>))}
        </StyledMenu>
    </div>
    );
};


export default StyledSelect;